import { AccordionButton, AccordionIcon, AccordionItem, AccordionPanel,Text, Box, Heading, Icon, List, ListIcon, ListItem } from "@chakra-ui/react";
import { IconType } from "react-icons";
import { FaCheckCircle } from "react-icons/fa";



interface ServiceAccordionItemsProps {
    accentColor: string;
    services: { title: string; icon: IconType; items: string[]; }[];
  }
  
  const ServiceAccordionItems = ({ accentColor , services } : ServiceAccordionItemsProps) => (
    <>
      {services.map((service, index) => (
        <AccordionItem key={index} borderColor="gray.200">
          <AccordionButton _expanded={{ bg: "gray.50" }} py={4}>
            <Box flex="1" textAlign="left" display="flex" alignItems="center">
              <Icon as={service.icon} color={accentColor} mr={3} />
              <Heading fontFamily="arial" size="sm">{service.title}</Heading>
            </Box>
            <AccordionIcon />
          </AccordionButton>
          <AccordionPanel pb={4}>
            <List spacing={2}>
              {service.items.map((item, idx) => (
                <ListItem key={idx} display="flex" alignItems="flex-start">
                  <ListIcon as={FaCheckCircle} color="green.500" mt={1} />
                  <Text>{item}</Text>
                </ListItem>
              ))}
            </List>
          </AccordionPanel>
        </AccordionItem>
      ))}
    </>
  );

  export default ServiceAccordionItems;